// "1d 02h Left"-style sale countdown labels only change once an hour, but the
// card lists that show them recomputed and re-rendered every second (a
// permanently busy main thread on phones). Callers now tick every
// COUNTDOWN_TICK_MS and keep the previous state object when nothing changed,
// which makes React skip the re-render entirely.
export const COUNTDOWN_TICK_MS = 30 * 1000;

export function sameLabels(prev, next) {
  const prevKeys = Object.keys(prev || {});
  const nextKeys = Object.keys(next || {});
  return prevKeys.length === nextKeys.length && nextKeys.every((k) => prev[k] === next[k]);
}
